import React from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentStatus } from 'components/QuestionnaireRequestAutomated/processor/slices/globalSlice'
import { SetPriceTask, FieldsTask, UploadTask, SignTask } from './tasks'

export default function AutomatedTasks() {
  const currentStatus = useSelector(selectCurrentStatus)
  const isStatusIntake = currentStatus === 'intake'
  const hasCanceled = currentStatus === 'canceled'
  const hasArchived = currentStatus === 'archived'

  return (
    <div className="dome-d-flex dome-flex-column">
      <SetPriceTask />
      <FieldsTask disabled={isStatusIntake || hasCanceled || hasArchived} />
      <UploadTask disabled={isStatusIntake || hasCanceled || hasArchived} />
      <SignTask disabled={isStatusIntake || hasCanceled || hasArchived} />
    </div>
  )
}
